module.exports = __webpack_public_path__ + "img/num_45.4d3194b3.png";